import * as React from "react";
const SvgQrCodeScannerUpperLeftCorner = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 25 25", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { stroke: "white", strokeWidth: 2, d: "M1 25V5a4 4 0 0 1 4-4h20", opacity: 0.7 }));
export default SvgQrCodeScannerUpperLeftCorner;
